export const shiftList = "SHIFT_LIST"